<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let typeDisplay of availableEventTypes" [value]="typeDisplay.type">
              {{ typeDisplay.display }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Date</mat-label>
          <input *ngIf="isBrowserSupportsDateInput; else datePicker" matInput placeholder="" type="date" required
            formControlName="date" />
          <ng-template #datePicker>
            <input matInput [matDatepicker]="picker" required formControlName="date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </ng-template>
          <mat-error>
            <span *ngIf="f('date').hasError('required')">Veuillez saisir une date</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-slide-toggle class="mt-3 mb-4" formControlName="energyImpact" [checked]="this.f('energyImpact').value"
          color="primary">Impacte la consommation d'énergie ?</mat-slide-toggle>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-12">
          <mat-label>Détails</mat-label>
          <textarea matInput placeholder="" type="text" required formControlName="details"></textarea>
          <mat-error>
            <span *ngIf="f('details').hasError('required')">Veuillez saisir les détails</span>
            <span *ngIf="f('details').hasError('maxlength')">Le détail ne peut pas dépasser 160 caractères</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>